var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 904,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M628.856 278.668V512c0 128.868-104.468 233.332-233.332 233.332-128.868 0-233.332-104.468-233.332-233.332 0-128.868 104.468-233.332 233.332-233.332h233.332z",
    fill: "#FD919F",
    "p-id": 906
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M576.856 278.668V512c0 120.072-90.712 218.92-207.332 231.856 8.54 0.948 17.208 1.476 26 1.476 128.868 0 233.332-104.468 233.332-233.332V278.668h-52z",
    fill: "#E0667D",
    "p-id": 907
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.52 512m-149.784 0a149.784 149.784 0 1 0 299.568 0 149.784 149.784 0 1 0-299.568 0Z",
    fill: "#D5E6F7",
    "p-id": 908
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M395.52 512m-92 0a92 92 0 1 0 184 0 92 92 0 1 0-184 0Z",
    fill: "#A0D1F2",
    "p-id": 909
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.52 512m-35.26 0a35.26 35.26 0 1 0 70.52 0 35.26 35.26 0 1 0-70.52 0Z",
    fill: "#7BABF3",
    "p-id": 910
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M628.856 278.668h56.828v120.808h-56.828z",
    fill: "#7BABF3",
    "p-id": 911
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M395.52 757.332c-135.276 0-245.332-110.056-245.332-245.332S260.244 266.668 395.52 266.668h233.332a12 12 0 0 1 12 12V512c0.004 135.276-110.052 245.332-245.332 245.332z m0-466.664c-122.044 0-221.332 99.288-221.332 221.332s99.288 221.332 221.332 221.332 221.332-99.288 221.332-221.332V290.668H395.52z",
    fill: "#504774",
    "p-id": 912
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M395.52 673.784c-89.208 0-161.784-72.58-161.784-161.784S306.312 350.216 395.52 350.216s161.784 72.58 161.784 161.784-72.572 161.784-161.784 161.784z m0-299.568c-75.976 0-137.784 61.808-137.784 137.784s61.812 137.784 137.784 137.784 137.784-61.808 137.784-137.784-61.808-137.784-137.784-137.784z",
    fill: "#504774",
    "p-id": 913
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M395.52 616c-57.344 0-104-46.652-104-104s46.656-104 104-104 104 46.652 104 104-46.652 104-104 104z m0-184c-44.112 0-80 35.888-80 80s35.888 80 80 80 80-35.888 80-80-35.888-80-80-80z",
    fill: "#504774",
    "p-id": 914
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M395.52 559.26c-26.06 0-47.26-21.204-47.26-47.26s21.2-47.256 47.26-47.256 47.26 21.2 47.26 47.256-21.2 47.26-47.26 47.26z m0-70.516A23.28 23.28 0 0 0 372.26 512c0 12.828 10.432 23.26 23.26 23.26s23.26-10.432 23.26-23.26a23.28 23.28 0 0 0-23.26-23.256zM685.684 411.472h-56.828a12 12 0 0 1-12-12V278.668a12 12 0 0 1 12-12h56.828a12 12 0 0 1 12 12v120.804a12 12 0 0 1-12 12z m-44.828-24h32.828V290.668h-32.828v96.804z",
    fill: "#504774",
    "p-id": 915
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M782.78 700.504c-25.292 0-45.872-20.576-45.872-45.868V396.084a21.896 21.896 0 0 0-21.872-21.872h-29.352a12 12 0 1 1 0-24h29.352c25.292 0 45.872 20.58 45.872 45.872v258.552c0 12.06 9.812 21.868 21.872 21.868s21.872-9.808 21.872-21.868V396.084c0-25.292 20.58-45.872 45.872-45.872h11.292a12 12 0 1 1 0 24h-11.292a21.896 21.896 0 0 0-21.872 21.872v258.552c0 25.292-20.58 45.868-45.872 45.868z",
    fill: "#504774",
    "p-id": 916
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloss);
export default __webpack_public_path__ + "static/media/floss.b912299fa13c7e3d315abd343a791c67.svg";
export { ForwardRef as ReactComponent };